import { __decorate } from "tslib";
import { Component, Vue, Ref, Watch } from 'vue-property-decorator';
import { getgroupTree, postDevicesGroup, deleteDevicesGroup, putDevicesGroup, } from '@blade-sxp/monitor/api/device-management/control';
import { AppModule } from '@blade/common/store/app';
let default_1 = class default_1 extends Vue {
    tree;
    form = { groupName: '' };
    title = '';
    groupName = '';
    dialogVisible = false;
    value = '';
    selectOpts = [];
    outerPage = 1;
    outerPageSize = 10;
    outerOpen = false;
    icon = false;
    mode = 'ORGAEDIT';
    currIndex = 0;
    parentId = 0;
    treeData = [];
    // private language = localStorage.getItem('language');
    command = 0;
    mounted() {
        this.getData();
    }
    get language() {
        // console.log('lang:', AppModule.language);
        return AppModule.language;
    }
    getData() {
        getgroupTree()
            .then((resp) => {
            this.treeData = resp.data.data.tree;
        })
            .catch((err) => {
            this.$message({
                message: err,
                type: 'error',
            });
        });
    }
    handleDrop() {
        console.log('drop');
    }
    handleNodeClick(node) {
        console.log(node);
        this.currIndex = node.id;
        this.parentId = node.parentId;
        this.$emit('getroup-id', node.id);
    }
    handleRenderContent(h, { node, data, store }) {
        if (data.level !== 0) {
            return (<div class="content-left-item">
          {data.parentId !== 0 && (<i class="el-icon-share" style="color:#ddd"></i>)}
          <div class={{ 'item-active': data.id === this.currIndex }} id="text-wraper">
            {data.name}
          </div>
          <div onClick={($e) => this.handleDropdown($e, data)} 
            // style="position:absolute;right:0px;z-index:9"
            style="position:absolute;right:0px;">
            <el-dropdown placement="bottom-right" trigger="click">
              <el-dropdown-menu class={{ on: this.icon }} slot="dropdown" id="cs">
                <el-dropdown-item command="1">
                  <i class="el-icon-news"></i>
                  {this.$t('device.createdAtTheSameLevel')}
                </el-dropdown-item>
                <el-dropdown-item command="2">
                  <i class="el-icon-share"></i>
                  {this.$t('device.createTheNextLevel')}
                </el-dropdown-item>
                <el-dropdown-item command="3">
                  <i class="el-icon-edit"></i>
                  {this.$t('device.groupRenaming')}
                </el-dropdown-item>
                <el-dropdown-item command="4">
                  <i class="el-icon-delete"></i>
                  {this.$t('common.delete')}
                </el-dropdown-item>
              </el-dropdown-menu>
              <i class="el-icon-more el-icon--right" 
            // style="transform: rotate(90deg);color:#fff;"
            style="transform: rotate(90deg);"></i>
            </el-dropdown>
          </div>
        </div>);
        }
    }
    handleDropdown($event, data) {
        this.groupName = '';
        if ($event.target.nodeName === 'LI') {
            if ($event.target.innerText === this.$t('device.createdAtTheSameLevel')) {
                // 创建同级
                this.title = `${this.$t('device.createdAtTheSameLevel')}`;
                this.command = 1;
                this.dialogVisible = true;
            }
            else if ($event.target.innerText === this.$t('device.createTheNextLevel')) {
                // 创建下一级
                this.title = `${this.$t('device.createTheNextLevel')}`;
                this.command = 2;
                this.dialogVisible = true;
            }
            else if ($event.target.innerText === this.$t('device.groupRenaming')) {
                // 分组重命名
                this.groupName = data.name;
                this.title = `${this.$t('device.groupRenaming')}`;
                this.command = 3;
                this.dialogVisible = true;
            }
            else {
                // 删除
                deleteDevicesGroup(this.currIndex)
                    .then((resp) => {
                    this.getData();
                    this.$message({
                        message: resp.data.message,
                        type: 'success',
                    });
                })
                    .catch((err) => {
                    this.$message({
                        message: err,
                        type: 'error',
                    });
                });
            }
        }
    }
    /**
     *@Description: 创建/修改 设备组
     *@Date: 2020-09-08 16:44:09
     */
    handleSubmit() {
        console.log(this.command);
        if (this.command === 1 || this.command === 2) {
            let data = { name: this.groupName, parentId: 0 };
            if (this.command === 1) {
                // 创建同级
                data.parentId = this.parentId;
            }
            else if (this.command === 2) {
                // 创建下一级
                data.parentId = this.currIndex;
                // console.log(data.parentId);
            }
            postDevicesGroup(data)
                .then((resp) => {
                this.getData();
                this.dialogVisible = false;
                this.$message({
                    message: resp.data.message,
                    type: 'success',
                });
            })
                .catch((err) => {
                this.$message({
                    message: err,
                    type: 'error',
                });
            });
        }
        else if (this.command === 3) {
            // 重命名
            putDevicesGroup(this.currIndex, { name: this.groupName })
                .then((resp) => {
                this.getData();
                this.dialogVisible = false;
                this.$message({
                    message: resp.data.message,
                    type: 'success',
                });
            })
                .catch((err) => {
                this.$message({
                    message: err,
                    type: 'error',
                });
            });
        }
    }
    creatFirst() {
        this.title = `${this.$t('device.createdAtTheSameLevel')}`;
        this.command = 1;
        this.parentId = 0;
        this.dialogVisible = true;
    }
    handleDragStart(node, $event) {
        this.$refs.tree.setCurrentKey(node.data.id);
        $event.dataTransfer.setData('drag', JSON.stringify(node.data));
    }
    handleDrag(node) {
        if (node.childNodes.length === 0) {
            return true;
        }
        return false;
    }
    handleSearch() {
        this.tree.filter(this.value);
    }
    // handleSearch() {
    //   console.log(11);
    //   const res: Array<{ id: number; name: string }> = [];
    //   this.flattenTree(this.treeData, res);
    //   const isfind = res.filter((item) => item.name.indexOf(this.value) >= 0);
    //   if (isfind.length > 0) {
    //     this.currIndex = isfind[0].id;
    //     (this.$refs.tree as any).setCurrentKey(isfind[0].id);
    //     console.log('expand:', (this.$refs.tree as any).store);
    //     (this.$refs.tree as any).store.nodesMap[
    //       isfind[0].id
    //     ].parent.expanded = true;
    //   }
    // }
    filterNode(value, data, node) {
        if (!value)
            return true;
        let one = data.name.indexOf(value) !== -1;
        let two = node.parent &&
            node.parent.data &&
            node.parent.data.name &&
            node.parent.data.name.indexOf(value) !== -1;
        let three = node.parent &&
            node.parent.parent &&
            node.parent.parent.data &&
            node.parent.parent.data.name &&
            node.parent.parent.data.name.indexOf(value) !== -1;
        let four = node.parent &&
            node.parent.parent &&
            node.parent.parent.parent &&
            node.parent.parent.parent.data &&
            node.parent.parent.parent.data.name &&
            node.parent.parent.parent.data.name.indexOf(value) !== -1;
        let five = node.parent &&
            node.parent.parent &&
            node.parent.parent.parent &&
            node.parent.parent.parent.parent &&
            node.parent.parent.parent.parent.data &&
            node.parent.parent.parent.parent.data.name &&
            node.parent.parent.parent.parent.data.name.indexOf(value) !== -1;
        let six = node.parent &&
            node.parent.parent &&
            node.parent.parent.parent &&
            node.parent.parent.parent.parent &&
            node.parent.parent.parent.parent.parent &&
            node.parent.parent.parent.parent.parent.data &&
            node.parent.parent.parent.parent.parent.data.name &&
            node.parent.parent.parent.parent.parent.data.name.indexOf(value) !== -1;
        let result_one = false;
        let result_two = false;
        let result_three = false;
        let result_four = false;
        let result_five = false;
        let result_six = false;
        if (node.level === 1) {
            result_one = one;
        }
        else if (node.level === 2) {
            result_two = one || two;
        }
        else if (node.level === 3) {
            result_three = one || two || three;
        }
        else if (node.level === 4) {
            result_four = one || two || three || four;
        }
        else if (node.level === 5) {
            result_five = one || two || three || four || five;
        }
        else if (node.level === 6) {
            result_six = one || two || three || four || five || six;
        }
        return (result_one ||
            result_two ||
            result_three ||
            result_four ||
            result_five ||
            result_six);
    }
    watchValue(newVal, oldVal) {
        // console.log(newVal);
        if (newVal == '') {
            this.tree.filter(this.value);
        }
    }
    watchLan(newVal) {
        console.log(newVal);
        if (newVal == 'en-us') {
            this.icon = true;
        }
        else {
            this.icon = false;
        }
    }
    handleClear() {
        this.value = '';
        this.getData();
    }
};
__decorate([
    Ref()
], default_1.prototype, "tree", void 0);
__decorate([
    Watch('value')
], default_1.prototype, "watchValue", null);
__decorate([
    Watch('language', { deep: true, immediate: true })
], default_1.prototype, "watchLan", null);
default_1 = __decorate([
    Component({
        name: 'ControlLeft',
        i18n: {
            messages: {
                'en-us': {
                    toAdd: 'No Record, click to add',
                },
                zh: {
                    toAdd: '暂无数据点击添加',
                },
            },
        },
    })
], default_1);
export default default_1;
